import { render, staticRenderFns } from "./en-website-info.vue?vue&type=template&id=4d9b938e&scoped=true"
import script from "./en-website-info.vue?vue&type=script&lang=js"
export * from "./en-website-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9b938e",
  null
  
)

export default component.exports